/**
 * @file Re-exports the Redactor component.
 */
import Redactor from "./Redactor";

export default Redactor;
